import { render, staticRenderFns } from "./AppNavbarHorizontalLayoutBrand.vue?vue&type=template&id=f3ebcff6&"
import script from "./AppNavbarHorizontalLayoutBrand.vue?vue&type=script&lang=js&"
export * from "./AppNavbarHorizontalLayoutBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports